<div class="signup-footer-controls-container">
   <div class="poweredby-logo"></div>
   <div [ngClass]="{'diamler-button-container': showPoweredByLogo, 'button-container': true}">
      <button class="back-btn btn btn-lg btn-outline-primary cp-back-button" *ngIf="showBackButton" (click)="backClicked.emit(); historyBack()" type='button' >{{ _backbuttonText }}</button>
      <button [disabled]="disabledNextButton" (click)="clickHandler()" class="btn btn-lg btn-primary" type='button' [cpAppFocusOnError]="focusOnError" >{{ nextButtonText }}</button>
   </div> 
</div>
